import { useEffect, useState } from "react";
import axios from "axios";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function GestionBureauxEloignesModal({ onClose, showPopup, onChanged }) {
  const [regions, setRegions] = useState([]);
  const [reg, setReg] = useState("");
  const [bureaux, setBureaux] = useState([]);
  const [eloignes, setEloignes] = useState(new Set());

  useEffect(() => {
    axios.get(`${API}/reference/regions`, { withCredentials: true })
      .then(r => setRegions(r.data || [])).catch(() => {});
    axios.get(`${API}/bureaux-eloignes`, { withCredentials: true })
      .then(r => setEloignes(new Set((r.data || []).map(b => `${b.noreg}-${b.nobur}`))))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!reg) { setBureaux([]); return; }
    axios.get(`${API}/reference/bureaux-by-region`, {
      params: { region: reg, include_all: true }, withCredentials: true,
    }).then(r => setBureaux(r.data || [])).catch(() => setBureaux([]));
  }, [reg]);

  const toggle = async (bur, checked) => {
    try {
      await axios.put(`${API}/admin/bureaux-eloignes`,
        { noreg: reg, nobur: bur, eloigne: checked }, { withCredentials: true });
      setEloignes(prev => {
        const s = new Set(prev);
        checked ? s.add(`${reg}-${bur}`) : s.delete(`${reg}-${bur}`);
        return s;
      });
      onChanged?.();
    } catch (err) {
      showPopup?.(err?.response?.data?.detail || "Erreur d'enregistrement.", "error", "Bureaux région éloignée");
    }
  };

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="etab-modal" onClick={e => e.stopPropagation()}
           style={{ maxWidth: 560, width: "94%" }}
           data-testid="bureaux-eloignes-modal">
        <div className="popup-header" style={{ background: "#0033A0", padding: "6px 12px" }}>
          <span className="popup-title">BUREAUX RÉGION ÉLOIGNÉE</span>
          <button className="win-modal-close" onClick={onClose} data-testid="bureaux-eloignes-btn-x">×</button>
        </div>
        <div style={{ padding: 16, fontSize: 13 }}>
          <p style={{ marginTop: 0 }}>
            Les demandes créées depuis un bureau coché auront la case
            <b> « Région éloignée »</b> cochée par défaut (équivalent du paramètre poste legacy).
          </p>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
            <span style={{ fontWeight: 600 }}>Région :</span>
            <select className="win-input" value={reg} onChange={e => setReg(e.target.value)}
                    style={{ flex: 1 }} data-testid="bureaux-eloignes-region">
              <option value=""></option>
              {regions.map(r => (
                <option key={r.code} value={r.code}>{r.code} {r.description}</option>
              ))}
            </select>
          </div>
          <div style={{ maxHeight: "40vh", overflow: "auto", border: "1px solid #c0c0c0", background: "#fff" }}>
            {bureaux.map(b => (
              <label key={b.code}
                     style={{ display: "flex", alignItems: "center", gap: 10,
                              padding: "6px 12px", borderBottom: "1px solid #eee", cursor: "pointer" }}>
                <input type="checkbox"
                       checked={eloignes.has(`${reg}-${b.code}`)}
                       onChange={e => toggle(b.code, e.target.checked)}
                       data-testid={`bureau-eloigne-${reg}-${b.code}`}
                       style={{ width: 15, height: 15 }} />
                <span>{b.code} — {b.bureau}</span>
              </label>
            ))}
            {reg && bureaux.length === 0 && (
              <div style={{ padding: 12, color: "#666" }}>Aucun bureau pour cette région.</div>
            )}
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 14 }}>
            <button className="win-btn" onClick={onClose} data-testid="bureaux-eloignes-btn-fermer">Fermer</button>
          </div>
        </div>
      </div>
    </div>
  );
}
